import { render, staticRenderFns } from "./FlickityCarousel.vue?vue&type=template&id=0e7cc606&"
import script from "./FlickityCarousel.vue?vue&type=script&lang=js&"
export * from "./FlickityCarousel.vue?vue&type=script&lang=js&"
import style0 from "flickity/dist/flickity.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports